import styled from 'styled-components';

export const NoWrap = styled.span`
  white-space: nowrap;
`;
